import { render } from "./App.vue?vue&type=template&id=c1b26072"
const script = {}
script.render = render

export default script